<template>
	<div class="content-wapper">
		<el-row class="navigation">
			<el-col align="left">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item :to="{ path: '' }">NQI服务</el-breadcrumb-item>
					<el-breadcrumb-item>医疗器械创新</el-breadcrumb-item>
				</el-breadcrumb>
			</el-col>
		</el-row>
		<el-row>
			<el-col :span="6">
				<el-row class="left-img">
					<img src="@/assets/images/zltszhfw/ylqxcx/menu_banner.jpg" />
				</el-row>
				<el-row class="botton-menus">
					<el-col :span="24">
						<div class="btn-menu">
							<el-link :underline="false" @click="openPage('zcfg','政策法规')">政策法规</el-link>
						</div>
						<div class="btn-menu">
							<el-link :underline="false" @click="openPage('jyzz','检验资质')">检验资质</el-link>
						</div>
						<div class="btn-menu">
							<el-link :underline="false" @click="openPage('qyzx','企业咨询')">企业咨询</el-link>
						</div>
						<div class="btn-menu">
							<el-link :underline="false" @click="openPage('lxwm','联系我们')">联系我们</el-link>
						</div>
					</el-col>
				</el-row>
			</el-col>
			<el-col :span="18" class="right-box">
				<template v-if="tableTitle=='政策法规'">
					<YlqxcxZcfg :tableTitle="tableTitle"></YlqxcxZcfg>
				</template>
				<template v-if="tableTitle=='企业咨询'">
					<YlqxcxQyzx :tableTitle="tableTitle"></YlqxcxQyzx>
				</template>
				<template v-if="tableTitle=='联系我们'">
					<YlqxcxLxwm :tableTitle="tableTitle"></YlqxcxLxwm>
				</template>
				<template v-if="tableTitle=='检验资质'">
					<YlqxcxJyzz :tableTitle="tableTitle"></YlqxcxJyzz>
				</template>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import YlqxcxZcfg from "./zcfg/index";
	import YlqxcxQyzx from "./qyzx/index";
	import YlqxcxLxwm from "./lxwm/index";
	import YlqxcxJyzz from "./jyzz/index";
	export default {
		name: "Ylqxcx",
		components: {
			YlqxcxZcfg,
			YlqxcxQyzx,
			YlqxcxLxwm,
			YlqxcxJyzz,
		},
		data() {
			return {
				tableTitle: "",
			}
		},
		created() {
			this.openPage('zcfg', '政策法规');
		},
		methods: {
			openPage(param1, param2) {
				this.tableTitle = param2;
			},

		}
	}
</script>

<style scoped>
	.content-wapper {
		margin-top: 5px;
		padding: 10px;
	}

	.navigation {
		padding: 20px 15px;
		line-height: 20px;
		height: 60px;
		background-color: #fafafa;
		margin-bottom: 15px;
	}

	.left-img img {
		width: 100%;
	}

	.botton-menus {
		min-height: 300px;
		width: 100%;
		background-color: #F5F5F5;
		box-sizing: border-box;
		padding: 30px 15px;
	}

	.btn-menu {
		background-color: #ececec;
		padding: 15px;
		margin-bottom: 10px;
		text-align: left;
	}

	.right-box {
		padding-left: 10px;
	}
</style>
